/** Semver build id: 1.2.3+abc1234 (git sha as build metadata). */
export function formatSemverBuildId(version: string, gitSha?: string | null): string {
  const semver = version.trim()
  const sha = gitSha?.trim()
  if (!semver) return sha || ''
  if (!sha) return semver
  return `${semver}+${sha}`
}

/** Human-readable label for profile / support: v1.2.3+abc1234 */
export function formatBuildVersionLabel(version: string, gitSha?: string | null): string {
  const semver = version.trim()
  if (!semver) {
    const sha = gitSha?.trim()
    return sha ? `build ${sha}` : ''
  }
  return `v${formatSemverBuildId(semver, gitSha)}`
}
